

import { NgModule } from '@angular/core';

import { MwcResizeObserverDirective } from './resize-observer.directive';
import { MwcResizeObserverFactory } from './resize-observer.service';

@NgModule({
  providers: [MwcResizeObserverFactory],
  declarations: [MwcResizeObserverDirective],
  exports: [MwcResizeObserverDirective]
})
export class MwcResizeObserverModule {}
